import { NavLink } from 'react-router-dom';
import { Bike, Calculator, Settings2 } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { hasModule } from '../../../utils/modulePermissions';

// Pestañas del módulo: Tablero (caja) · Corte del día · Configuración (solo manage).
export default function DeliveryNav({ right }: { right?: React.ReactNode }) {
  const { currentUser } = useAuth();
  const tabs = [
    { to: '/dashboard/repartos', label: 'Tablero', icon: Bike, end: true },
    { to: '/dashboard/repartos/corte', label: 'Corte del día', icon: Calculator },
    ...(hasModule(currentUser, 'delivery', 'manage') ? [{ to: '/dashboard/repartos/configuracion', label: 'Configuración', icon: Settings2 }] : []),
  ];
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 print:hidden">
      <h1 className="flex items-center gap-2 text-xl font-bold text-content">
        <Bike size={22} className="text-accent" /> Repartos
      </h1>
      <nav className="flex gap-1 rounded-xl bg-surface-2 p-1">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end}
            className={({ isActive }) => `flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition ${
              isActive ? 'bg-surface text-content shadow-sm' : 'text-content-2 hover:text-content'}`}>
            <t.icon size={15} /> {t.label}
          </NavLink>
        ))}
      </nav>
      {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
    </div>
  );
}
